import React, { useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IModel } from "./MonsterSetting";
import MonsterCompanySettingTable from "./monsterCompanySetting/MonsterCompanySettingTable";
import MonsterBranchSettingTable from "./monsterBranchSetting/MonsterBranchSettingTable";
import MonsterTeamSettingTable from "./monsterTeamSetting/MonsterTeamSettingTable";
import MonsterUserSettingTable from "./monsterUserSetting/MonsterUserSettingTable";

interface IProps {
  setModal: (modal: IModel) => void;
  toast: any;
  permissions: IPermissionProps;
  reload: boolean;
}

const Table = (props: IProps) => {
  const [activeIndex, setActiveIndex] = useState<number | number[]>();
  const openEdit = () => {
    props.setModal({ open: true });
  };
  const handleCollapseAll = () => {
    setActiveIndex([]);
  };

  const handleExpandAll = () => {
    setActiveIndex([0, 1, 2, 3]);
  };

  const leftToolbarTemplate = () => {
    return (
      <>
        <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
        <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
      </>
    );
  };

  const rightToolbarTemplate = () => {
    return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />;
  };

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        {(_roles.includes(1) || _roles.includes(4)) && (
          <AccordionTab header="Monster Company Wise Setting">
            <MonsterCompanySettingTable />
          </AccordionTab>
        )}
        {(_roles.includes(1) || _roles.includes(4)) && (
          <AccordionTab header="Monster Branch Wise Setting">
            <MonsterBranchSettingTable />
          </AccordionTab>
        )}
        {(_roles.includes(1) || _roles.includes(4) || _roles.includes(6))  && (
          <AccordionTab header="Monster Team Wise Setting">
            <MonsterTeamSettingTable />
          </AccordionTab>
        )}
        {(_roles.includes(1) || _roles.includes(4) || _roles.includes(6)) && (
          <AccordionTab header="Monster User Wise Setting">
            <MonsterUserSettingTable />
          </AccordionTab>
        )}
      </Accordion>
    </>
  );
};

export default Table;
